import { TextDocumentDto, ViewDocumentAsOwnerDto } from "../../../../autogen/bff-api";
import { CombinedDocuments } from "../../../../common/documents/CombinedDocuments";

interface Props {
  uploadedDocuments: ViewDocumentAsOwnerDto[];
  textDocuments: TextDocumentDto[];
  isLoading: boolean;
}

export const Documents = ({ uploadedDocuments, textDocuments, isLoading }: Props) => (
  <CombinedDocuments
    uploadedDocuments={uploadedDocuments}
    textDocuments={textDocuments}
    isLoading={isLoading}
    isTagsColumnVisible={true}
  />
);
